import React from 'react'
import { Col, Row } from 'reactstrap'
import { isMobile } from '../../utils/deviceInfo'

export function LayoutHeading({
  children,
  colWidth,
  className,
  colWidthMobile,
  plainTable,
}) {
  return (
    <Col
      md={colWidth}
      xs={colWidthMobile || colWidth}
      className={
        plainTable
          ? 'plain-table-action-heading'
          : `action-heading cursor-pointer bg-white ${className} mobile-head-wrapper`
      }>
      {children}
    </Col>
  )
}

export function LayoutHeadingLight({
  children,
  colWidth,
  className,
  colWidthMobile,
  plainTable,
}) {
  return (
    <Col
      md={colWidth}
      xs={colWidthMobile || colWidth}
      className={
        plainTable
          ? 'plain-table-action-heading'
          : `action-heading-light cursor-pointer${className} mobile-head-wrapper`
      }>
      {children}
    </Col>
  )
}

export function LayoutRow({
  children,
  className,
  plainTable,
  style,
  noHeight,
}) {
  return (
    <Row
      style={{ ...style }}
      className={`${className} ${!noHeight && 'planning-row-mobile-height'}`}>
      {children}
    </Row>
  )
}

export function LayoutData({
  children,
  colWidth,
  className,
  colWidthMobile,
  plainTable,
  customStyle = {},
}) {
  return (
    <Col
      md={colWidth}
      xs={colWidthMobile || colWidth}
      className={
        plainTable
          ? 'plain-table-data'
          : `action-table-data ${className} p-2 border border-grey`
      }
      style={{
        ...customStyle,
      }}>
      {children}
    </Col>
  )
}

export function ActionLayoutData({
  children,
  colWidth,
  className,
  colWidthMobile,
  plainTable,
  fullWidth,
  noDefault,
  customStyle,
}) {
  const currentStyle = {
    width: fullWidth
      ? '-webkit-fill-available'
      : isMobile
      ? `${colWidth * 120.5}px`
      : `${colWidth * 122}px`,
  }
  return (
    <div
      style={{ ...customStyle, ...currentStyle }}
      className={
        plainTable
          ? `${className} plain-table-data`
          : `${
              noDefault ? '' : 'action-table-data '
            } ${className} p-2 border border-grey`
      }>
      {children}
    </div>
  )
}

export function ActionLayoutHeading({
  children,
  colWidth,
  className,
  colWidthMobile,
  plainTable,
  fullWidth,
}) {
  return (
    <div
      style={{
        minWidth: fullWidth
          ? '100%'
          : isMobile
          ? `${colWidth * 120.5}px`
          : `${colWidth * 122}px`,
      }}
      className={
        plainTable
          ? `plain-table-action-heading ${className}`
          : `action-heading cursor-pointer bg-white ${className} mobile-head-wrapper`
      }>
      {children}
    </div>
  )
}
export function ActionLayoutHeadingPlainBordered({
  children,
  colWidth,
  className,
  colWidthMobile,
  plainTable,
  fullWidth,
}) {
  return (
    <div
      style={{
        minWidth: fullWidth
          ? '100%'
          : isMobile
          ? `${colWidth * 120.5}px`
          : `${colWidth * 122}px`,

        maxWidth: fullWidth
          ? '100%'
          : isMobile
          ? `${colWidth * 120.5}px`
          : `${colWidth * 122}px`,
      }}
      className={'plain-table-action-heading2 ' + className}>
      {children}
    </div>
  )
}

export function ActionLayoutDataPlainBordered({
  children,
  colWidth,
  className,
  colWidthMobile,
  plainTable,
  fullWidth,
  customStyle,
  onClick,
  noPadding
}) {
  return (
    <div
      style={{
        width: fullWidth
          ? '100%'
          : isMobile
          ? `${colWidth * 120.5}px`
          : `${colWidth * 122}px`,
        height: '70px',
        ...(customStyle ? customStyle : {}),
      }}
      className={
        plainTable
          ? 'hide-scroll plain-table-data p-bor border-gray-thin'
          : `hide-scroll action-table-data p-bor border-gray-thin ${className} ${noPadding ? '' : 'p-2'}`
      }
      onClick={onClick}>
      {children}
    </div>
  )
}
